<template>
  <div id="result" class="result_container container">
    <div class="result_header">
      <h3 v-bind:aria-label="title">
        <span>{{ title }}</span>
      </h3>
    </div>
    <div class="result_text">
      <p>Hieronder zie je de juiste antwoorden en of je de vraag goed of fout hebt beantwoord.</p>
    </div>
    <div class="compare-question" v-for="question in questions" :key="question.name">
        <hr>
        <p>{{ question.title }}
            <span class="correct" v-if="question.value == question.correctAnswer">Goed</span>
            <span class="incorrect" v-else>Fout</span>
        </p>
        <div v-for="choice in question.choices" :key="choice.value">
            <label :aria-label="choice.value">
                <input type="radio" :value="choice.value" disabled :checked="choice.value == question.value">
                <i class="choice-label" v-if="choice.value == question.value">{{choice.value}}</i>
                <span class="choice-label" v-else>{{choice.value}}</span>
            </label>
            <i v-if="choice.value == question.correctAnswer" class="pds-c-icon check green"></i>
            <i v-if="choice.value !== question.correctAnswer && choice.value == question.value" class="pds-c-icon error red"></i>
        </div>
    </div>
    <div class="sv_nav result_navigate">
      <router-link to="/result">
        <div>Terug naar resultaat</div>
      </router-link>
    </div>
    <Socials />
  </div>
</template>

<script>
import Socials from '../components/Socials.vue';

export default {
  name: "CompareResults",
  components: {
    Socials
  },
  computed: {
    title() {
      return this.$store.state.config.title;
    },
    questions() {
        return this.$store.state.quizQuestions;        
    }
  },
  beforeMount() {
    if (!this.$store.state.quizQuestions) {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.compare-question {
    margin-bottom: 30px;
    padding-left:10px;
    padding-right: 10px;
}

.compare-question hr {
    margin-top: 30px;
    margin-bottom: 30px;
}

.choice-label {
  margin-left: 4px;
  margin-right: 4px;
}

.correct {
    color: #58a333;
}

.incorrect {
    color: #d60d41;
}

</style>